module.exports = __webpack_public_path__ + "img/dummylogo.f614eb88.jpg";